// extracted by mini-css-extract-plugin
export default {"container":"NoAccess_container__kyiFp","image":"NoAccess_image__rJXZ0","title":"NoAccess_title__iEUAL","description":"NoAccess_description__vP-U0"};